module.exports = __webpack_public_path__ + "assets/img/CTA-cartoucherie-numerisation_A.bb3927c5.jpg";